import React, { Component } from "react";
import "./Governance.css";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import upIcon from '../../assets/images/up.png';

export default class Governance extends Component {
    constructor() {
        super();
        this.state = {
            show: true,
            showDisclaimer: true,
            isVisible: false
        };
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.jumpHome = this.jumpHome.bind(this);
    }

    showModal = () => {
        this.setState({ show: true });
    };

    hideModal = () => {
        this.setState({ show: false });
    };

    hideDisclaimer = () => {
        this.setState({ showDisclaimer: false });
    };

    componentDidMount() {
        this.deleteAllCookies();
        window.addEventListener('scroll', this.toggleVisibility);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.toggleVisibility);
    }

    deleteAllCookies() {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }

        localStorage.clear();
        sessionStorage.clear();
    }

    toggleVisibility = () => {
        if (window.pageYOffset > 0) {
            this.setState({ isVisible: true });
        } else {
            this.setState({ isVisible: false });
        }
    };

    jumpHome() {
        document.getElementById("navbarId").scrollIntoView({ behavior: "smooth" });
    }

    render() {
        return (
            <div>
                <div className="introSection" id="introId">
                    <div className="masthead-contact">
                        <div className="logo-governance">
                            <h1 className="logo-services-title">Governance</h1>
                        </div>
                    </div>
                    {this.state.isVisible && (
                        <button className="floatingButton" onClick={this.jumpHome}>
                            <img className="up" src={upIcon} alt="up arrow icon" />
                        </button>
                    )}
                    <Container>
                        <Row className="justify-content-center rowCol">
                            <Col lg={12}>
                                <p className="mainTitle">Governance</p>
                                <p className="mainBlurb bgBlurb blurbMargins">
                                    Streetlink Homeless Support is resolute in its commitment
                                    to providing the highest quality service to all stakeholders.
                                    This commitment is demonstrated through strict adherence
                                    to the highest standards of governance and quality.
                                    Our organisational policies, governance, and quality
                                    standards form the backbone of our strategy within the
                                    context of evolving national/regional strategies,
                                    standards, policies, and action plans.
                                    <br/><br/>
                                    RCN: 20206746 | CHY: 23218
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>


                <br />
                <h4>Copyright 2025 Streetlink Homeless Support.</h4>
                <br />
            </div>
        );
    }
}
